export var validateEmail = function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isValidEmail = re.test(String(email).toLowerCase());
    return {
        isValidEmail: isValidEmail,
        sanitizedValue: email.toLowerCase(),
    };
};
export var validatePassword = function (password) {
    // between 8 to 30 char, at least one letter and one number
    var minConditions = /^(?=.*[A-Za-z])(?=.*\d).{8,30}$/.test(password);
    // check for whitespace
    var whiteSpace = /\s/.test(password);
    if (minConditions && !whiteSpace) {
        return true;
    }
    else {
        return false;
    }
};
